// The logo — the brand's single source of truth (docs/Context.md §4).
// Presentational only; callers control size and any framing/animation.

export function Logo({ className }: { className?: string }) {
  return (
    <img
      src="/logo.png"
      alt="Citrus-Dala — what you must"
      className={className}
      draggable={false}
    />
  );
}
